module.exports = __webpack_public_path__ + "static/media/HambMenu.99c6bf5f.svg";